<!-- Loading.vue -->
<template>
    <div v-if="loading" class="loading-spinner">
      <!-- Loading indicator, e.g., spinner or progress bar -->
      <div class="spinner"></div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
    computed: {
      loading() {
        // Access the Apollo Client's loading state
        return this.$apollo.loading;
      },
    },
  };
  </script>

<style>
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px; /* Adjust the height as needed */
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>